import React from "react";
import Icon, { IconName } from "../icon";
var ToolbarSubscriptionRequiredLink = function ToolbarSubscriptionRequiredLink(_ref) {
    var status = _ref.status, openModal = _ref.openModal, iconName = _ref.iconName, title = _ref.title, withSpotlight = _ref.withSpotlight;
    var renderIcon = function renderIcon(disabled, customTooltip) {
        if (disabled === void 0) {
            disabled = false;
        }
        return /*#__PURE__*/ React.createElement(Icon, {
            iconName: iconName,
            color: disabled ? "#cccccc" : withSpotlight ? "#005C16" : "#ff5b00",
            className: "w-8 mb-2",
            tooltip: customTooltip || title
        });
    };
    var openLoginModal = function openLoginModal() {
        return openModal("LOGIN_REQUIRED");
    };
    var openSubscriptionModal = function openSubscriptionModal() {
        return openModal("SUBSCRIPTION_REQUIRED");
    };
    var getUnavailableMessage = function getUnavailableMessage() {
        return iconName === IconName.PDF ? "PDF nicht verfügbar" : "Audio nicht verfügbar";
    };
    var getLoadingMessage = function getLoadingMessage() {
        return iconName === IconName.PDF ? "PDF wird geladen..." : "Audio wird geladen...";
    };
    var getDeactivatedMessage = function getDeactivatedMessage() {
        return iconName === IconName.PDF ? "PDF deaktiviert" : "Audio deaktiviert";
    };
    switch (status.status) {
        case "ERROR":
            return /*#__PURE__*/ React.createElement("div", {
                className: "block cursor-not-allowed opacity-50",
                title: getUnavailableMessage()
            }, renderIcon(true, getUnavailableMessage()));
        case "LOADING":
            return /*#__PURE__*/ React.createElement("div", {
                className: "block cursor-default opacity-60",
                title: getLoadingMessage()
            }, renderIcon(true, getLoadingMessage()));
        case "DEACTIVATED":
            return /*#__PURE__*/ React.createElement("div", {
                className: "block cursor-not-allowed opacity-50",
                title: getDeactivatedMessage()
            }, renderIcon(true, getDeactivatedMessage()));
        case "LOGIN_REQUIRED":
            return /*#__PURE__*/ React.createElement("button", {
                className: "block cursor-pointer",
                onClick: openLoginModal
            }, renderIcon());
        case "SUBSCRIPTION_REQUIRED":
            return /*#__PURE__*/ React.createElement("button", {
                className: "block cursor-pointer",
                onClick: openSubscriptionModal
            }, renderIcon());
    } // TODO In firefox, .mp3 links are not downloaded per default but rather played in firefox.
    return /*#__PURE__*/ React.createElement("a", {
        href: status.url,
        className: "block cursor-pointer",
        target: "_blank",
        rel: "noopener noreferrer",
        title: title
    }, renderIcon());
};
export default ToolbarSubscriptionRequiredLink;
